import React, { useContext } from 'react';
import AssetCategoryTable from '../accountReport/AssetCategoryTable';
import styles from './AccountReportRoot.module.scss';
import assetAccountContext from '../../context/assetAccountContext';
import BackgroundBar from '../styled/BackgroundBar';

const AccountReportRoot: React.FC = () => {
  const { selectedAccount } = useContext(assetAccountContext);
  let assetCategories: AssetCategory[] = [];
  let asOfDate = '';

  if (selectedAccount) {
    asOfDate = selectedAccount.dailyReport.asOfDate;
    assetCategories = selectedAccount.dailyReport.assets;
  }

  const tables = assetCategories.map((ac, index) => (
    <BackgroundBar key={index} className={styles['report-root']}>
      {index === 0 && (
        <div className={styles['holdings-title']}>Daily Portfolio Holdings</div>
      )}
      <AssetCategoryTable
        key={ac.assetName}
        asOfDate={asOfDate}
        assetCategory={ac}
        includeDisclaimer={ac.assetName.toLowerCase() === 'equities'}
      />
    </BackgroundBar>
  ));

  return <>{tables}</>;
};

export default AccountReportRoot;
